<template>
  <div class="row recursive-row" v-show="show">
    <div class="col-sm-6 ellipsis-text align-self-center">
      <indented-span :level="2">
        <a :href="download.product_url" target="_blank">{{ download.name }}</a>
      </indented-span>
    </div>
    <div class="col-sm-4 ellipsis-text align-self-center">
      <indented-span :level="2">
        <a
          v-if="download.checksum_url"
          :href="download.checksum_url"
          target="_blank"
        >
          <span class="badge badge-info"
            ><font-awesome-icon icon="clipboard-check" /> CHECKSUM</span
          >
        </a>
      </indented-span>
    </div>
    <div
      class="col-sm-2 text-right align-self-center"
      v-if="isSuperUser || isStaffUser"
    >
      <button class="btn btn-sm" @click="selectDownload">Select</button>
    </div>
  </div>
</template>

<script>
import IndentedSpan from "../IndentedSpan.vue";
import config from "../../constants/config";
import { mapGetters } from "vuex";

export default {
  components: {
    IndentedSpan
  },
  name: "DownloadRow",
  props: {
    download: Object,
    show: Boolean
  },
  methods: {
    selectDownload() {
      this.$store.commit("product/selectDownload", this.download);
      this.$bvModal.show(config.DOWNLOAD_MODAL_ID);
    }
  },
  computed: {
    ...mapGetters("user", ["isSuperUser", "isStaffUser"])
  }
};
</script>
